import axiosClient from "../../../api/axiosClient";

const BASE_URL = "/api/trading/sales-orders";

const tradingSalesOrderService = {
  getSalesOrders(params = {}) {
    return axiosClient.get(`${BASE_URL}/`, { params });
  },

  getSalesOrder(salesOrderId) {
    return axiosClient.get(`${BASE_URL}/${salesOrderId}`);
  },

  createSalesOrderFromQuotation(quotationId, payload = {}) {
    return axiosClient.post(
      `${BASE_URL}/from-quotation/${quotationId}`,
      payload
    );
  },

  updateSalesOrder(salesOrderId, payload) {
    return axiosClient.put(
      `${BASE_URL}/${salesOrderId}`,
      payload
    );
  },

  submitForApproval(salesOrderId, payload = {}) {
    return axiosClient.post(
      `${BASE_URL}/${salesOrderId}/submit-for-approval`,
      payload
    );
  },

  getAuditHistory(salesOrderId) {
    return axiosClient.get(
      `${BASE_URL}/${salesOrderId}/history`
    );
  },

  cancelSalesOrder(salesOrderId, cancellationReason) {
    return axiosClient.post(
      `${BASE_URL}/${salesOrderId}/cancel`,
      { reason: cancellationReason }
    );
  },
  getQuotationsEligibleForSalesOrder() {
    return axiosClient.get(
        "/api/trading/quotations/eligible-for-sales-order"
    );
},
  getFulfilmentSummary(salesOrderId) {
    return axiosClient.get(
      `${BASE_URL}/${salesOrderId}/fulfilment-summary`
    );
  },
};

export default tradingSalesOrderService;